query allUltimateTeams(
  $first: Int,
  $offset: Int,
  $filter: UltimateTeamFilter,
  ) {
  teams: allUltimateTeams(
      first: $first,
      offset: $offset,
      filter: $filter
    ) {
    nodes {
        squad
        shortName
        name
        source
        teamId
        division
        stadium
        city
        state
        mappings: ultimateTeamMappingsByIntId {
        nodes {
          extId
          extRef
          feed
          mappingType
        }
      }
    }
    totalCount
  }
}
